<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-select
        v-model="selectedCilindroTipo"
        :label="'Tipo cilindro'"
        :spanColumn="8"
        :settings="{
          placeholder: 'Seleccionar cilindro',
          options: cilindroTipoList,
        }"
      ></custom-select>

      <el-col
        :span="4"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrar"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="limpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  computed,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useCylinderAdapterStore } from '../stores/cylinder_adapters_store.js';
import IconDelete from '~icons/mdi/delete';

const cilindroTipoStore = useCilindroTipoStore();
const cylinderAdapterStore = useCylinderAdapterStore();

const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { cylinderAdapterFilters } = storeToRefs(cylinderAdapterStore);
const { emptyList, setPage, findAllCilindroAdaptadorHTTP, resetFilter } = cylinderAdapterStore;

const selectedCilindroTipo = computed({
  get: () =>
    cilindroTipoList.value.find(
      (it) => it.Codigo === cylinderAdapterFilters.value.CodigoCilindroTipo,
    ) || null,
  set: (value) => {
    cylinderAdapterFilters.value.CodigoCilindroTipo = value?.Codigo || null;
  },
});

const limpiarFiltros = () => {
  setPage(1);
  emptyList();
  resetFilter();
  findAllCilindroAdaptadorHTTP();
};

const filtrar = () => {
  setPage(1);
  emptyList();
  findAllCilindroAdaptadorHTTP();
};

onBeforeMount(async () => {
  await cilindroTipoStore.firstCilindroTipo();
});
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.button-container {
  margin-top: auto;
}
</style>
